module.exports = __webpack_public_path__ + "img/roast.4c4fe94c.svg";